module.exports = __webpack_public_path__ + "static/media/mastercard.8344e47d.svg";